// console.log('hi i am here');
const renderSelect = (option, formId) => {
  let html = "";

  const popularSnacks = option.snacks.filter((snack) => snack.popular);

  let loopNum = 0;
  for (i = 0; i < option.qty; i++) {
    html =
      html +
      `
	  <div class="hflex"> 
        <label for="${option.label}${option.qty > 1 ? "-" + (i + 1) : ""}">${option.label} ${option.qty > 1 ? i + 1 : ""}</label>
	    ${option.tooltip ? renderToolTip(option.tooltip) : ""}
	  </div>
      <select required class="select-box" id="${option.label}${option.qty > 1 ? "-" + (i + 1) : ""}" name="properties[${
        option.name
      }${option.qty > 1 ? "-" + (i + 1) : ""}]" form=${formId}>
      ${option.snacks.map(
        (snack) => {
          let selected = "";
          if (popularSnacks && popularSnacks.length > 0) { // if popular is configured
            if (snack.sku == popularSnacks[loopNum].sku) { // if current sku = current popular snack
              selected = "selected";
            }
          }

          return `<option ${selected} 
          value="${snack.name} [${snack.sku}]" ${snack.popular ? 'class="popular-option"' : ""} title="${
          snack.tooltip || "Click to select"
        }" >${snack.name}${snack.weight ? " " + snack.weight + snack.unit : ""}</option>
        `}
      )}
      </select>
      `;

    loopNum = loopNum + 1;
    if (loopNum === popularSnacks.length) {
      loopNum = 0; // restart
    }
  }

  return html;
};

const renderCheckBoxes = (option, formId) => {
  let html = `<div class="hflex"> <label>${option.label}</label>`;

  html = html + `<input type="hidden" id="${option.name}" name="properties[${option.name}]" form="${formId}">`;
  option.tooltip ? (html = html + renderToolTip(option.tooltip) + `</div>`) : (html = html + `</div>`);

  html =
    html +
    option.snacks
      .map((snack) => {
        const uniqueName = `${snack.name}${snack.weight ? " " + snack.weight + snack.unit : ""}`; // note: id must be unique as there can be multiple snacks with same name but different weight
        return `
    <div class="checkbox_option">
    <input class="checkbox_input" type="checkbox" id="${uniqueName}" hidden-data="${option.name}" 
      onchange="fillHidden('${option.name}', ${option.maxChecked}, this)" value="${snack.name} [${
          snack.sku
        }]" form="${formId}">
    <label for="${uniqueName}" ${snack.popular ? 'class="popular-option"' : ""} title="${
          snack.tooltip || "Click to select"
        }" for="${snack.name}">
      ${uniqueName}
    </label>
    </div>
    `;
      })
      .join("");

  return html;
};

const renderFileUpload = (option, formId) => {
  return `
  <div>
    <div class="hflex">
      <label class="field__label" for="file">${option.label}</label>
      <div class="tooltip" data-direction="bottom">
        <div class="tooltip__initiator">
          <!-- element with tooltip hover call -->
          <span class="svg-wrapper"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#1C274C" stroke-width="1.5"></circle> <path d="M12 17V11" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#1C274C"></circle> </g></svg></span>
          </div>
        <div class="tooltip__item">
          ${option.tooltip}
        </div>
      </div>
    </div>
    <input class="file-input" type="file" id="file" name="properties[${option.name}]" form="${formId}">
  </div>
	`;
};

const renderDate = (option, formId) => {
  return `
  <div class="hflex"><label for="myDatePicker">${option.label}</label></div>
  <div class="input-container">
    <input type="date" id="myDatePicker" form="${formId}" name="properties[${option.name}]">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
    </svg>
  </div>
  `;
};

const renderTimeSlot = (option, formId) => {
  return `
    <div class="hflex">
     <label for="timeslot">${option.label}</label>
    </div>    
    <select class="select-box" id="timeslot" name="properties[${option.name}]" form="${formId}">
      <option value="9:00-12:00">9:00 AM - 12:00 PM</option>
      <option value="12:00-15:00" selected>12:00 PM - 3:00 PM</option>
      <option value="15:00-18:00">3:00 PM - 6:00 PM</option>
    </select>
  `;
};

const renderHamperDatePicker = (option, formId) => {
  return `
    <p style="padding-bottom: 10px;">Price includes scheduled delivery. Book your delivery date and timeslot here:</p>
    <div class="grid-2col">
      <label for="myDatePicker">Date</label>
      <div class="input-container">
        <input style="width: 100%" type="text" id="myDatePicker" form="${formId}" name="properties[Date]" placeholder="Select Date">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
        </svg>
      </div>
           <label for="timeslot">Timeslot</label>
      <select class="select-box" id="timeslot" name="properties[Timeslot]" form="${formId}">
        <option value="9:00-12:00">9:00 AM - 12:00 PM</option>
        <option value="12:00-15:00">12:00 PM - 3:00 PM</option>
        <option value="15:00-18:00">3:00 PM - 6:00 PM</option>
      </select>
    </div>
  `;
};

const renderImageHtml = (option, formId) => {
  let html = option.images.map(({ name, url }) => {
    return `
      <input type="radio" id="${name}" name="properties[${option.name}]" value="${name}" form="${formId}">
      <label for="${name}">
        <img src="${url}" alt="${name}">
        <div class="tick-mark">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path fillRule="evenodd"
              d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z"
              clipRule="evenodd" />
          </svg>
        </div>
      </label>
    `;
  });

  // encapsulate elements
  html.unshift(`
    <div class="hflex">
      <label>${option.label}</label>
      ${option.tooltip ? renderToolTip(option.tooltip) : ""}
    </div>
    <div class="image-select">`);
  html.push(`
      <div class="file-upload">
        <div class="hflex">
          <span class="svg-wrapper"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#1C274C" stroke-width="1.5"></circle> <path d="M12 17V11" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#1C274C"></circle> </g></svg></span>
          <label class="field__label" for="file">You can upload your design here or email us for inspiration.</label>
        </div>
        <input class="file-input" type="file" id="file" name="properties[${option.name}-file]" form="${formId}">
      </div>
    </div>
  `);

  return html.join("");
};

const renderToolTip = (input) => {
  return `
  <div class="tooltip" data-direction="bottom">
    <div class="tooltip__initiator">
      <span class="svg-wrapper"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#1C274C" stroke-width="1.5"></circle> <path d="M12 17V11" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#1C274C"></circle> </g></svg></span>
    </div>
    <div class="tooltip__item">
      ${input}
    </div>
  </div>
`;
};

const renderDisplayHtml = ({ html }) => {
  return `<div class="custom-display">
            ${html}
          </div>`;
};

const renderTextArea = (option, formId) => {
  return `<div><label for="${option.name}">${option.label}</label></div>
  <textarea id="${option.name}" name="properties[${option.name}]" form="${formId}" rows=${3} >
  </textarea>
  `;
};

const addPopularChoices = () => {
  const popular_el = document.querySelectorAll(".popular-option");
  popular_el.forEach((el) => {
    el.innerHTML = el.innerHTML + `<span> &starf;</span>`;
  });
};

function fillHidden(hiddenname, maxChecked = 999, event) {
  const checkboxes = document.querySelectorAll('[hidden-data="' + hiddenname + '"]');

  // get the total number of boxes checked
  let checked = 0;
  checkboxes.forEach((box) => {
    if (box.checked) checked = checked + 1;
  });

  // do nothing if maximum allowable reached
  if (checked > maxChecked) {
    event.checked = false;
    return;
  }

  // else update line item property value
  var hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = "";
  var i;
  for (i = 0; i < checkboxes.length; i++) {
    var x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value == "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}

/* only for custom medley */
const renderCustomMedley = (option, formId) => {
  let html = `<div class="hflex"> <label>${option.label}</label>`;

  html = html + `<input type="hidden" id="${option.name}" name="properties[${option.name}]" form="${formId}">`;
  option.tooltip ? (html = html + renderToolTip(option.tooltip) + `</div>`) : (html = html + `</div>`);

  html =
    html +
    option.snacks
      .map((snack) => {
        return `
    <div class="checkbox_option">
    <input 
      class="checkbox_input" 
      type="checkbox"
      id="${snack.name}"
      hidden-data="${option.name}"
      onchange="fillCustomMedleyHidden('${option.name}', ${option.maxChecked}, this, ${option.totalWeight}, '${
          snack.unit
        }')" 
      form="${formId}">
        <label 
          for="${snack.name}" 
          ${snack.popular ? 'class="popular-option"' : ""}
          title="${snack.tooltip || "Click to select"}"
          for="${snack.name}">
          ${snack.name} ${
          !snack.isHalfPortion ? `<span id="custom-full-weight"></span>` : `<span id="custom-half-weight"></span>`
        }
        </label>
    </div>
    `;
      })
      .join("");

  return html;
};

function fillCustomMedleyHidden(hiddenname, maxChecked = 999, event, totalWeight = 200, unit = "g") {
  const checkboxes = document.querySelectorAll('[hidden-data="' + hiddenname + '"]');

  let checked = 0; // keep track of total checked
  checkboxes.forEach((box) => {
    if (box.checked && box.checked < maxChecked) {
      checked = checked + 1;
    }
  });

  // do nothing if maximum allowable reached
  if (checked > maxChecked) {
    event.checked = false;
    return;
  }

  // update weights
  const weightPerServing = Math.ceil(totalWeight / checked);
  checkboxes.forEach((box) => {
    const labelEl = box.nextElementSibling; // box is the input element, the next element is the label element
    const spanEl = labelEl.firstElementChild; // this will be the span element to insert weight

    // updates display html
    if (box.checked) {
      if (spanEl.id === "custom-full-weight") {
        spanEl.innerHTML = `${weightPerServing}${unit}`;
      }
      if (spanEl.id === "custom-half-weight") {
        spanEl.innerHTML = `${Math.ceil(weightPerServing / 2)}${unit}`;
      }
    } else {
      spanEl.innerHTML = "";
    }

    box.value = String(labelEl.textContent).trim(); // value is the content we will see in backend properties
  });

  // update line item property value
  let hiddenfield = document.getElementById(hiddenname);
  hiddenfield.value = "";
  let i;
  for (i = 0; i < checkboxes.length; i++) {
    let x = checkboxes[i];
    if (x.checked) {
      if (hiddenfield.value == "") {
        hiddenfield.value = x.value;
      } else {
        hiddenfield.value = hiddenfield.value + ", " + x.value;
      }
    }
  }
}
/* custom medley code ends */

function renderFlatPickr() {
  flatpickr("#myDatePicker", {
    minDate: new Date().fp_incr(4),
    maxDate: "2026-12-31",
    // defaultDate: new Date().setDate(new Date() + 2),
    defaultDate: new Date().fp_incr(4),
    disable: [
      "2026-05-01", 
      "2026-06-01",
      "2026-08-10", 
      "2026-11-09", 
      "2026-12-24",
      "2026-12-25",
      "2026-12-31",  
      function (date) {
        // return true to disable
        return date.getDay() === 0 || date.getDay() === 6;
      },
    ],
  });
}
